module.exports = "/_next/static/images/icon-vtour-blue-big-50c0e44c58058fd191f1a988c280db29.png";